import React, { Fragment, useEffect } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/logo.svg';

const TicketPage = () => {

  useEffect(() => {
    if (!document.getElementById('donorbox-widgets')) {
      const script = document.createElement('script');
      script.src = 'https://donorbox.org/widgets.js?language=en-us';
      script.type = 'module';
      script.async = true;
      script.defer = true;
      script.id = 'donorbox-widgets';
      document.body.appendChild(script);
    }
  }, []);

  return (
    <Fragment>
      <Navbar Logo={Logo} hclass={'wpo-site-header-s5'} />
<img src="/1.jpg"  />

      <div style={{ textAlign: 'center', padding: '50px 20px' }}>
        <div
          style={{ maxWidth: '500px', margin: '0 auto' }}
          dangerouslySetInnerHTML={{
            __html: `
              <dbox-widget
                type="event"
                campaign="904597">
              </dbox-widget>
            `
          }}
        />
      </div>

      <Footer />
    </Fragment>
  );
};

export default TicketPage;
